import { render, staticRenderFns } from "./spanish_alphabet_video.vue?vue&type=template&id=98377048&scoped=true"
import script from "./spanish_alphabet_video.vue?vue&type=script&lang=js"
export * from "./spanish_alphabet_video.vue?vue&type=script&lang=js"
import style0 from "./spanish_alphabet_video.vue?vue&type=style&index=0&id=98377048&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98377048",
  null
  
)

export default component.exports